import styled, { css } from 'styled-components';
import { Scrollbar } from '../../theme';
import { Input } from '../../ui/Input/Input';
import { rem } from '../../utils';
export const StyledWrapper = styled.div `
  position: relative;
  display: inline-block;
  width: 100%;
  &:hover svg {
    fill: ${({ theme }) => theme.Color.Neutrals.Dark};
  }
`;
export const iconStyle = css `
  position: absolute;
  cursor: pointer;
  top: 50%;
  transform: translateY(-50%);
  user-select: none;
  width: ${({ theme }) => rem(theme.Icon.Size.Medium)};
  height: ${({ theme }) => rem(theme.Icon.Size.Medium)};
`;
export const StyledActionButtonContainer = styled.div `
  position: absolute;
  height: ${({ theme }) => rem(theme.Icon.Size.Medium)};
  transform: translateY(-50%);
  top: 50%;
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => rem(theme.Spacing.Size.XXXSmall)};
  right: ${({ theme }) => rem(theme.Spacing.Size.XSmall)};
`;
export const StyledActionButton = styled.a `
  cursor: pointer;
`;
export const StyleSearchIcon = styled.a `
  ${iconStyle}
  left: ${({ theme }) => rem(theme.Spacing.Size.XSmall)};
  cursor: text;
  pointer-events: none;
`;
export const StyledInput = styled(Input) `
  ${({ theme }) => {
    const iconSize = theme.Icon.Size.Medium;
    const spacing = theme.Spacing.Size.XSmall;
    const padding = theme.Spacing.Size.XXSmall;
    const totalSpacing = iconSize + spacing + padding;
    return css `
      padding-left: ${rem(totalSpacing)} !important;
      padding-right: ${rem(totalSpacing)} !important;
    `;
}}
`;
export const StyledSearchItems = styled.div `
  position: absolute;
  display: flex;
  flex-direction: column;
  top: calc(100% + ${({ theme }) => rem(theme.Spacing.Size.XSmall)});
  max-height: 10rem;
  width: 100%;
  padding: ${({ theme }) => rem(theme.Spacing.Size.XSmall)};
  border: 1px solid ${({ theme }) => theme.Color.Neutrals.Border};
  border-radius: ${({ theme }) => rem(theme.Border.Radius.Medium)};
  background-color: ${({ theme }) => theme.Color.Neutrals.Paper};

  overflow-y: auto;
  ${Scrollbar.Default};

  ${({ hasContent }) => !hasContent &&
    css `
      display: none;
    `}
`;
//# sourceMappingURL=SearchBox.style.js.map